module.exports = __webpack_public_path__ + "img/tree-unfold.c545c469.svg";